import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { handleSmoothScroll } from '../utils/scrollUtils';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 py-4">
      <button
        className="flex justify-between items-center w-full text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-medium text-[#0a2540]">{question}</h3>
        <span className="ml-6 flex-shrink-0">
          {isOpen ? (
            <svg className="h-6 w-6 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          ) : (
            <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </span>
      </button>
      {isOpen && (
        <div className="mt-2 pr-12">
          <p className="text-gray-600">{answer}</p>
        </div>
      )}
    </div>
  );
};

const FAQSection = () => {
  const faqs = [
    {
      question: "Quels types de sites web développez-vous ?",
      answer: "Nous développons tous types de sites web, des vitrines professionnelles aux e-commerces complexes, en passant par les applications web sur mesure. Notre expertise couvre les technologies modernes comme React, Vue.js, et les CMS comme WordPress. Nous adaptons notre approche à vos besoins spécifiques pour créer une solution digitale qui répond parfaitement à vos objectifs."
    },
    {
      question: "Combien coûte la création d'un site web ?",
      answer: "Le coût varie en fonction de la complexité du projet, des fonctionnalités requises et du délai de réalisation. Nous proposons des solutions adaptées à différents budgets, avec des tarifs transparents établis après analyse de vos besoins. Contactez-nous pour obtenir un devis personnalisé gratuit qui détaillera précisément les prestations et le budget nécessaire."
    },
    {
      question: "Quel est votre délai de réalisation pour un projet web ?",
      answer: "Les délais dépendent de l'envergure du projet. Un site vitrine peut être réalisé en 3 à 4 semaines, tandis qu'un e-commerce ou une application web sur mesure nécessitera généralement 2 à 3 mois. Nous établissons un planning détaillé dès le début du projet et vous tenons informés de l'avancement à chaque étape pour garantir le respect des délais convenus."
    },
    {
      question: "Proposez-vous des services de maintenance après la mise en ligne ?",
      answer: "Oui, nous offrons plusieurs formules de maintenance pour assurer la pérennité de votre site. Nos services incluent les mises à jour de sécurité, l'optimisation des performances, les sauvegardes régulières, et l'assistance technique. Nous pouvons également vous accompagner dans l'évolution de votre site avec l'ajout de nouvelles fonctionnalités selon vos besoins."
    },
    {
      question: "Comment optimisez-vous le référencement (SEO) de vos sites ?",
      answer: "Nous intégrons les bonnes pratiques SEO dès la conception du site : structure optimisée, temps de chargement rapide, compatibilité mobile, et code propre. Nous mettons en place les balises méta appropriées, une structure de contenu hiérarchisée, et veillons à l'optimisation des images. Nous pouvons également vous proposer un accompagnement SEO plus poussé avec création de contenu optimisé et suivi de positionnement."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="text-center mb-16">
          <motion.h2 
            className="text-2xl md:text-3xl lg:text-4xl font-medium mb-6 text-[#0a2540] leading-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Questions fréquemment posées
          </motion.h2>
          
          <motion.p 
            className="text-gray-600 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Vous avez des questions ? Nous avons les réponses. Si vous ne trouvez pas ce que vous cherchez, n'hésitez pas à nous contacter.
          </motion.p>
        </div>
        
        <motion.div 
          className="max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </motion.div>
        
        <div className="text-center mt-12">
          <a 
            onClick={(e) => handleSmoothScroll(e, 'contact')} 
            className="px-5 py-2 rounded-[40px] bg-[#5046E5] text-white font-medium hover:bg-[#4038c2] transition-all duration-300 shadow-lg text-sm inline-flex items-center"
          >
            Contactez-nous
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
